var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElectrical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "electrical-a",
    d: "M68.4701801,36.875 C70.999477,36.875 72.5717426,39.6229935 71.300285,41.796875 L47.237785,83.359375 C46.6361691,84.3983841 45.5424191,85 44.3940617,85 C42.302158,85 40.7162739,83.0449486 41.208408,80.9667969 L47.5112225,54.375 L31.2826801,54.375 C29.3002583,54.375 27.7689816,52.6250267 28.0288006,50.6562233 L32.4038006,17.8437233 C32.6224972,16.2168503 34.0170551,15 35.6576801,15 L55.3451801,15 C57.4916912,15 59.0639568,17.0507812 58.5170818,19.128933 L52.692783,36.875 L68.4701801,36.875 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#1C7B97",
    xlinkHref: "#electrical-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrical);
export default __webpack_public_path__ + "static/media/electrical.7962c610.svg";
export { ForwardRef as ReactComponent };